/**
 * Definitions of the logger instance.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */
import { configureLogger } from '@amplify3/duplo-back-end'
import { isEnvProduction } from './env'

/**
 * Tags used to filter webapp's own tagged logs via VITE_LOG_TAG in .env.
 */
export enum LogTag {
  BillingPage = '#billing-page',
  FileUploader = '#file-uploader',
  HomePage = '#home-page',
  Module = '#module',
  TaskCreationPage = '#task-creation-page',
  TaskList = '#task-list',
  Util = '#util',
}

export const LOG_TAG_LIST = import.meta.env.VITE_LOG_TAG
export const logger = configureLogger(
  !isEnvProduction,
  LOG_TAG_LIST,
  import.meta.env.DEV
)
